import { storeOrUpdateTeam } from '@/api/team'
import { getCorporations, getPlatforms, getKvData } from '@/api/open'
import Sortable from 'sortablejs'

export default {
    components: {},
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            labelCol: {span: 5},
            wrapperCol: {span: 17},
            medias: [],
            corporations: [],
            loading: false,
            rules: {
                name: [{required: true, message: '请填写小组名称', trigger: 'change'}],
                corporation_id: [{required: true, message: '请选择主体', trigger: 'change'}],
            },
            platforms:[],
            mediaCorporations: [],
            sortableInstance: null,

        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted() {
        getCorporations().then(res => {this.corporations = res.data.list || []})
        getPlatforms().then(res => {this.platforms = res.data.list || []})
        if (this.model.corporation_id) {
            // this.kvData(this.model.corporation_id)
            this.changeMediaCorporationType(this.model.media_corporation_type)
        }

        this.$nextTick(() => {
            this.initDrag()
          })
    },
    watch: {
        'model.media_corporations': {
            handler() {
              this.initDrag();
            },
            deep: true,
          },
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.model)
            this.loading = true
            storeOrUpdateTeam(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.model.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        },
        kvData(corporation_id) {
            getKvData({type:100, corporation_id: corporation_id}).then(res => {
                this.mediaCorporations = res.data.list || []
            })
        },
        changeCorporation() {
            // this.kvData(corporation_id)
            this.changeMediaCorporationType(this.model.media_corporation_type)
        },
        changeMediaCorporationType(media_corporation_type) {
            console.log('media_corporation_type', media_corporation_type)
            let type = 100
            let flag = null
            if (media_corporation_type == 2) {
                type = 102
                flag = 'getName'
            }
            getKvData({type:type, corporation_id: this.model.corporation_id, flag:flag}).then(res => {
                this.mediaCorporations = res.data.list || []
            })
        },
        initDrag() {
            this.$nextTick(() => {
              const container = this.$refs.dragContainer;
              if (!container || !(container instanceof HTMLElement)) return;
          
              // 如果已存在 sortable 实例，先销毁
              if (this.sortableInstance) {
                this.sortableInstance.destroy();
              }
          
              this.sortableInstance = Sortable.create(container, {
                animation: 150,
                onEnd: (evt) => {
                  // 拖拽结束后，根据新顺序调整 this.model.media_corporations
                  const movedItem = this.model.media_corporations.splice(evt.oldIndex, 1)[0];
                  this.model.media_corporations.splice(evt.newIndex, 0, movedItem);
                }
              });
            });
          }
          ,
          removeSelected(item) {
            const index = this.model.media_corporations.indexOf(item)
            if (index !== -1) {
              this.model.media_corporations.splice(index, 1)
            }
          }
    }
}
